import base from '@/views/base/base.vue'
import KeepAliveRouteView from '@/views/base/KeepAliveRouteView.vue'

const indexManagement = () => import('@/views/index/index.vue')
// 0607新增
/*补货管理*/
const addReplenishmentApplication = () => import('@/views/replenishment-application/add/index.vue') // 新增补货申请
/*商品管理*/
const goods = () => import('@/views/goods/goods/index.vue') // 商品报表
const movement = () => import('@/views/goods/movement/index.vue') // 商品进销存报表
const storeList = () => import('@/views/goods/storeList/index.vue') // 商品进销存报表
const details = () => import('@/views/goods/details/index.vue') // 商品明细报表
const goodsOnline = () => import('@/views/goods/goods-online/index.vue') // 线上商品
const goodsImport = () => import('@/views/goods/goods-import/index.vue') //商品导入
/*订货管理*/
const managementOrder = () => import('@/views/management/order/index.vue') // 销售订货流水
const managementOrderdetail = () => import('@/views/management/orderdetail/index.vue') // 销售订货流水明细
const managementShortage = () => import('@/views/management/shortage/index.vue') // 缺货分析报表
const managemenDeliveryflow = () => import('@/views/management/deliveryflow/index.vue') // 发货流水
const managemenDeliveryflowdetail = () => import('@/views/management/deliveryflowdetail/index.vue') // 发货流水报表明细
/*销售管理*/
const storeIncome = () => import('@/views/sales/store-income/index.vue') // 店铺收支
const order = () => import('@/views/sales/order/index.vue') // 销售订单流水
const financialaudit = () => import('@/views/sales/order/financialaudit/index.vue')
const orderdetail = () => import('@/views/sales/orderdetail/index.vue') // 销售订单流水明细
const orderuncleared = () => import('@/views/sales/orderuncleared/index.vue') // 销售订单未结清
const remittance = () => import('@/views/sales/remittance/index.vue') // 销售明细按款汇总
const sumcustomer = () => import('@/views/sales/sumcustomer/index.vue') // 客户报表汇总
const billingNew = () => import('@/views/sales/billing-new/index.vue') // 销售开单(新)
const verification = () => import('@/views/sales/billing/verification/index.vue') // 核销
const onlineOrderManagement = () => import('@/views/sales/online-order/index.vue') // 线上订单管理
const onlineOrderDetail = () => import('@/views/sales/online-order/detail/index.vue') // 线上订单详情
const unsold = () => import('@/views/sales/unsold-summary/index.vue') // 核销
/* 采购管理 */
const purchasedetail = () => import('@/views/purchase/purchasedetail/index.vue') // 采购入库流水明细 <- 采购订单流水明细
const detailedpayment = () => import('@/views/purchase/detailedpayment/index.vue') // 采购入库按款汇总 <- 采购明细按款汇总
const purchase = () => import('@/views/purchase/purchase/index.vue') // 采购订货流水明细
const shortage = () => import('@/views/purchase/shortage/index.vue') // 缺货分析
const addPurchaseInventory = () => import('@/views/purchase/addPurchaseInventory/index.vue') // 新增采购入库
const purchaseInventory = () => import('@/views/purchase/purchaseInventory/index.vue') // 采购流水
const purchaseInventoryIndex = () => import('@/views/purchase/purchaseInventoryIndex/index.vue') // 采购入库
const importTable = () => import('@/views/purchase/importTable/index.vue') // 导表入库表
const purchaseImportTable = () => import('@/views/purchase/purchaseImportTable/index.vue') // 导表订货开单
const supplierManagement = () => import('@/views/purchase/supplierManagement/index.vue') // 供应商管理
/*财务管理*/
const finance = () => import('@/views/finance/finance/index.vue') // 财务流水
const poscashierwater = () => import('@/views/finance/poscashierwater/index.vue') // pos收银流水
const nuclearaccounthistory = () => import('@/views/finance/nuclearaccounthistory/index.vue') // 财务核账历史
const supplierstatement = () => import('@/views/finance/supplierstatement/index.vue') // 供应商对账单
const proSupplierstatement = () => import('@/views/finance/pro-supplierstatement/index.vue') // 企业供应商对账单
const writeoffdetails = () => import('@/views/finance/writeoffdetails/index.vue') // 核销明细报表
/*仓库管理*/
const allocatinginvoice = () => import('@/views/warehouse/allocatinginvoice/index.vue') // 调拨开单
const allocatingoutput = () => import('@/views/warehouse/allocatingoutput/index.vue') // 调拨出库记录
const allocatinginput = () => import('@/views/warehouse/allocatinginput/index.vue') // 调拨入库记录
const allocatingwater = () => import('@/views/warehouse/allocatingwater/index.vue') // 调拨流水
const allocatingdetail = () => import('@/views/warehouse/allocatingdetail/index.vue') // 调拨明细
const singlesheet = () => import('@/views/warehouse/singlesheet/index.vue') // 盘点单列表
// 文章详情
const notice = () => import('@/views/article-management/notice/index.vue') // 公告
const article = () => import('@/views/article-management/article/index.vue') // 文章详情
const learningFeedback = () => import('@/views/article-management/learningFeedback/index.vue') // 学习反馈
// 主攻商品
const product = () => import('@/views/main-product/product/index.vue') // 主攻商品
// 渠道发货
const storeInvoice = () => import('@/views/channel/storeInvoice/index.vue') // 门店发货单
const returnStoreInvoice = () => import('@/views/channel/returnStoreInvoice/index.vue') // 门店退货单
const withReturnStoreInvoice = () => import('@/views/channel/withReturnStoreInvoice/index.vue') // 门店带退货
const billDetailsInvoice = () => import('@/views/channel/billDetails/index.vue') // 渠道发货明细订单
// 线上订单导入
const onlineDataImport = () => import('@/views/online-order/data-import/index.vue') // 数据导入
// 微商城
const miniShopOrder = () => import('@/views/mini-shop/order/index.vue') // 微商城订单流水
const miniShopOrderDetail = () => import('@/views/mini-shop/orderdetail/index.vue')
const shopDecoration = () => import('@/views/mini-shop/shop-decoration/index.vue') // 微商城订单明细
const shopDecorationEditor = () => import('@/views/mini-shop/shop-decoration/editor/index.vue') // 微商城订单明细
// 系统管理
const print = () => import('@/views/set/print/index.vue') // 打印管理
const design = () => import('@/views/set/print/design/index.vue') // 打印管理
// 库存管理
const inventory = () => import('@/views/stock/inventory/index.vue') // 库存报表
const inventorySales = () => import('@/views/stock/inventory-sales/index.vue') // 库存进存销报表
const inventorySalesDetail = () => import('@/views/stock/inventory-sales/detail/index.vue') // 库存进存销报表明细
const goodsInventorySales = () => import('@/views/stock/goods-inventory-sales/index.vue') // 商品进存销报表
const goodsInventorySalesDetail = () => import('@/views/stock/goods-inventory-sales/detail/index.vue') // 库存进存销报表明细
const outbounddetail = () => import('@/views/stock/outbounddetail/index.vue') // 出库明细报表
const storingdetail = () => import('@/views/stock/storingdetail/index.vue') // 入库明细报表

const RouteView = {
  name: 'RouteView',
  render: (h) => h('router-view'),
}

const route = [
  {
    path: '/',
    name: 'Base',
    component: base,
    meta: { title: process.APP.INDEX_ROUTE_NAME },
    children: [
      {
        path: '/index',
        key: '/index',
        meta: {
          title: '首页',
        },
        component: indexManagement,
        children: [],
      },
      {
        path: '/replenishment-application',
        name: 'replenishment-application',
        key: '/replenishment-application',
        meta: {
          title: '补货申请管理',
        },
        component: KeepAliveRouteView,
        children: [
          {
            path: 'add',
            key: '/replenishment-application/add',

            meta: {
              title: '新增补货申请',
            },
            component: addReplenishmentApplication,
          },
        ],
      },
      {
        path: '/goods',
        name: 'goods',
        key: '/goods',
        meta: {
          title: '商品管理',
        },
        component: KeepAliveRouteView,
        children: [
          {
            path: 'goods',
            key: '/goods/goods',
            meta: {
              title: '商品报表',
            },
            component: goods,
          },
          {
            name: 'goodsManagement',
            path: 'goods-management',
            key: '/goods/goods-management',
            meta: {
              title: '商品管理',
              keepAlive: true,
            },
            component: () => import('@/views/goods/goods-management/index.vue'),
          },
          {
            path: 'goods-management/detail',
            meta: {
              title: '商品详情',
            },
            component: () => import('@/views/goods/goods-management/detail/index.vue'),
          },
          {
            path: 'movement',
            key: '/goods/movement',
            meta: {
              title: '商品进销存报表',
            },
            component: movement,
          },
          {
            path: 'storeList',
            key: '/goods/storeList',

            meta: {
              title: '多门店商品报表',
            },
            component: storeList,
          },
          {
            path: 'details',
            key: '/goods/details',

            meta: {
              title: '商品明细报表',
            },
            component: details,
          },
          // {
          //   path: 'inventory',
          //   key: '/goods/inventory',

          //   meta: {
          //     title: '库存报表',
          //   },
          //   component: inventory,
          // },
          {
            name: 'goodsOnline',
            path: 'goods-online',
            key: '/goods/goods-online',
            meta: {
              title: '线上商品管理',
              keepAlive: true,
            },
            component: goodsOnline,
          },
          {
            path: 'goods-import',
            key: '/goods/goods-import',
            meta: {
              title: '商品导入',
            },
            component: goodsImport,
          },
        ],
      },
      {
        path: '/management',
        name: 'management',
        key: '/management',

        meta: {
          title: '订货管理',
        },
        component: KeepAliveRouteView,
        children: [
          {
            path: 'managementOrder',
            key: '/management/managementOrder',
            meta: {
              title: '销售订货流水',
            },
            component: managementOrder,
          },
          {
            path: 'managementOrderdetail',
            key: '/management/managementOrderdetail',
            meta: {
              title: '销售订货流水明细',
            },
            component: managementOrderdetail,
          },
          {
            path: 'managementShortage',
            key: '/management/managementShortage',
            meta: {
              title: '缺货分析报表',
            },
            component: managementShortage,
          },
        ],
      },
      {
        path: '/sales',
        name: 'sales',
        key: '/sales',

        meta: {
          title: '销售管理',
        },
        component: KeepAliveRouteView,
        children: [
          {
            path: 'storeIncome',
            key: '/sales/storeIncome',

            meta: {
              title: '店铺收支',
            },
            component: storeIncome,
          },
          {
            path: 'order',
            key: '/sales/order',
            name: 'SalesOrder',
            meta: {
              title: '销售订单流水',
              keepAlive: true,
            },
            component: order,
          },
          {
            path: 'order/financialaudit',
            key: '/sales/order/financialaudit',

            meta: {
              title: '财务核账',
            },
            component: financialaudit,
          },
          {
            path: 'orderdetail',
            key: '/sales/orderdetail',

            meta: {
              title: '销售订单流水明细',
            },
            component: orderdetail,
          },
          {
            path: 'orderuncleared',
            key: '/sales/orderuncleared',

            meta: {
              title: '销售订单未结清',
            },
            component: orderuncleared,
          },

          {
            path: 'remittance',
            key: '/sales/remittance',

            meta: {
              title: '销售明细按款汇总',
            },
            component: remittance,
          },
          {
            path: 'unsold',
            key: '/sales/unsold',

            meta: {
              title: '商品滞销汇总',
            },
            component: unsold,
          },
          {
            path: 'sumcustomer',
            key: '/sales/sumcustomer',

            meta: {
              title: '客户报表汇总',
            },
            component: sumcustomer,
          },
          {
            path: 'billing',
            key: '/sales/billing',

            meta: {
              title: '销售开单',
            },
            component: billingNew,
          },
          {
            path: 'verification',
            key: '/sales/verification',

            meta: {
              title: '核销',
              children: true,
            },
            component: verification,
          },
          {
            path: 'managemenDeliveryflow',
            key: '/management/managemenDeliveryflow',
            meta: {
              title: '发货流水报表',
            },
            component: managemenDeliveryflow,
          },
          {
            path: 'managemenDeliveryflowdetail',
            key: '/management/managemenDeliveryflowdetail',
            meta: {
              title: '发货流水明细报表',
            },
            component: managemenDeliveryflowdetail,
          },
          {
            name: 'onlineOrderManagement',
            path: 'onlineOrderManagement',
            key: '/sales/onlineOrderManagement',
            meta: {
              title: '线上订单管理',
              keepAlive: true,
            },
            component: onlineOrderManagement,
          },
          {
            path: 'onlineOrderDetail',
            key: '/sales/onlineOrderDetail',
            meta: {
              title: '线上订单详情',
            },
            component: onlineOrderDetail,
          },
        ],
      },
      {
        path: '/purchase',
        name: 'purchase',
        key: '/purchase',
        meta: {
          title: '采购管理',
        },
        component: KeepAliveRouteView,
        children: [
          // 供应商管理
          {
            path: 'supplierManagement',
            key: '/purchase/supplierManagement',
            meta: {
              title: '供应商管理',
            },
            component: supplierManagement,
          },

          {
            path: 'purchasedetail',
            key: '/purchase/purchasedetail',

            meta: {
              title: '采购入库流水明细',
            },
            component: purchasedetail,
          },
          {
            path: 'detailedpayment',
            key: '/purchase/detailedpayment',

            meta: {
              title: '采购入库按款汇总',
            },
            component: detailedpayment,
          },
          {
            path: 'purchase',
            key: '/purchase/purchase',
            meta: {
              title: '采购订货流水明细',
            },
            component: purchase,
          },
          {
            path: 'shortage',
            key: '/purchase/shortage',
            meta: {
              title: '缺货分析报表',
            },
            component: shortage,
          },
          {
            path: 'addPurchaseInventory',
            key: '/purchase/addPurchaseInventory',
            meta: {
              title: '采购入库',
            },
            component: addPurchaseInventory,
          },
          {
            name: 'purchaseInventory',
            path: 'purchaseInventory',
            key: '/purchase/purchaseInventory',

            meta: {
              title: '采购流水',
              keepAlive: true,
            },
            component: purchaseInventory,
          },
          {
            path: 'purchaseInventoryIndex',
            key: '/purchase/purchaseInventoryIndex',
            meta: {
              title: '详情',
            },
            component: purchaseInventoryIndex,
          },
          {
            path: 'importTable',
            key: '/purchase/importTable',
            meta: {
              title: '导表入库',
            },
            component: importTable,
          },
          {
            path: 'purchaseImportTable',
            key: '/purchase/purchaseImportTable',
            meta: {
              title: '品牌订货',
            },
            component: purchaseImportTable,
          },
        ],
      },
      {
        path: '/finance',
        name: 'finance',
        key: '/finance',

        meta: {
          title: '财务管理',
        },
        component: KeepAliveRouteView,
        children: [
          {
            path: 'finance',
            key: '/finance/finance',

            meta: {
              title: '财务流水',
            },
            component: finance,
          },
          {
            path: 'poscashierwater',
            key: '/finance/poscashierwater',

            meta: {
              title: 'pos收银流水',
            },
            component: poscashierwater,
          },
          {
            path: 'nuclearaccounthistory',
            key: '/finance/nuclearaccounthistory',

            meta: {
              title: '财务核账历史',
            },
            component: nuclearaccounthistory,
          },
          {
            path: 'supplierstatement',
            key: '/finance/supplierstatement',

            meta: {
              title: '供应商对账单',
            },
            component: supplierstatement,
          },
          {
            path: 'proSupplierstatement',
            key: '/finance/pro-supplierstatement',

            meta: {
              title: '企业版供应商对账单',
            },
            component: proSupplierstatement,
          },

          {
            path: 'writeoffdetails',
            key: '/finance/writeoffdetails',

            meta: {
              title: '核销明细报表',
            },
            component: writeoffdetails,
          },
        ],
      },
      {
        path: '/stock',
        name: 'stock',
        key: '/stock',

        meta: {
          title: '库存管理',
        },
        component: KeepAliveRouteView,
        children: [
          {
            path: 'inventory',
            key: '/stock/inventory',

            meta: {
              title: '库存报表',
            },
            component: inventory,
          },
          {
            path: 'goodsInventorySales',
            key: '/stock/goodsInventorySales',
            meta: {
              title: '商品进存销报表',
            },
            component: goodsInventorySales,
            children: [
              {
                path: 'detail',
                name: 'goodsInventorySalesDetail',
                meta: {
                  title: '明细',
                },
                component: goodsInventorySalesDetail,
              },
            ],
          },
          {
            path: 'inventorySales',
            name: 'inventorySales',
            key: '/stock/inventorySales',
            meta: {
              title: '仓库进销存报表',
              keepAlive: true,
            },
            component: inventorySales,
            children: [
              {
                path: 'detail',
                name: 'inventorySalesDetail',
                meta: {
                  title: '明细',
                },
                component: inventorySalesDetail,
              },
            ],
          },

          {
            path: 'outbounddetail',
            key: '/stock/outbounddetail',

            meta: {
              title: '出库明细报表',
            },
            component: outbounddetail,
          },
          {
            path: 'storingdetail',
            key: '/stock/storingdetail',

            meta: {
              title: '入库明细报表',
            },
            component: storingdetail,
          },
        ],
      },
      {
        path: '/warehouse',
        name: 'warehouse',
        key: '/warehouse',

        meta: {
          title: '仓库管理',
        },
        component: KeepAliveRouteView,
        children: [
          {
            path: 'allocatinginvoice',
            key: '/warehouse/allocatinginvoice',
            meta: {
              title: '调拨开单',
            },
            component: allocatinginvoice,
          },
          {
            path: 'allocatingoutput',
            name: 'allocatingoutput',
            key: '/warehouse/allocatingoutput',
            meta: {
              title: '调拨出库记录',
              keepAlive: true,
            },
            component: allocatingoutput,
          },
          {
            path: 'allocatingoutput/detail',
            meta: {
              title: ' 调拨出库详情',
              children: true,
            },
            component: () => import('@/views/warehouse/allocatingoutput/detail/index.vue'),
          },
          {
            path: 'allocatinginput',
            name: 'allocatinginput',
            key: '/warehouse/allocatinginput',
            meta: {
              title: '调拨入库记录',
              keepAlive: true,
            },
            component: allocatinginput,
          },
          {
            path: 'allocatinginput/detail',
            meta: {
              title: ' 调拨入库详情',
              children: true,
            },
            component: () => import('@/views/warehouse/allocatinginput/detail/index.vue'),
          },
          {
            path: 'allocatingwater',
            key: '/warehouse/allocatingwater',

            meta: {
              title: '调拨流水',
            },
            component: allocatingwater,
          },
          {
            path: 'allocatingdetail',
            key: '/warehouse/allocatingdetail',

            meta: {
              title: '调拨明细',
            },
            component: allocatingdetail,
          },
          {
            path: 'singlesheet',
            key: '/warehouse/singlesheet',

            meta: {
              title: '盘点单列表',
              keepAlive: true,
            },
            component: singlesheet,
          },
          // {
          //   path: 'outbounddetail',
          //   key: '/warehouse/outbounddetail',

          //   meta: {
          //     title: '出库明细报表',
          //   },
          //   component: outbounddetail,
          // },
          // {
          //   path: 'storingdetail',
          //   key: '/warehouse/storingdetail',

          //   meta: {
          //     title: '入库明细报表',
          //   },
          //   component: storingdetail,
          // },
        ],
      },
      {
        path: '/article',
        name: 'article',
        key: '/article',
        meta: {
          title: '文章详情',
        },
        component: KeepAliveRouteView,
        children: [
          {
            path: 'notice',
            key: '/article/notice',
            meta: {
              title: '公告设置',
            },
            component: notice,
          },
          {
            path: 'article',
            key: '/article/article',
            meta: {
              title: '文章详情',
            },
            component: article,
          },
          {
            path: 'learningFeedback',
            key: '/article/learningFeedback',
            meta: {
              title: '学习反馈',
            },
            component: learningFeedback,
          },
        ],
      },
      {
        path: '/product',
        name: 'product',
        key: '/product',
        meta: {
          title: '主攻商品',
        },
        component: KeepAliveRouteView,
        children: [
          {
            path: 'product',
            key: '/main-product/product',
            meta: {
              title: '主攻商品',
            },
            component: product,
          },
        ],
      },
      {
        path: '/channel',
        name: 'channel',
        key: '/channel',
        meta: {
          title: '渠道发货',
        },
        component: KeepAliveRouteView,
        children: [
          {
            path: 'storeInvoice',
            key: '/channel/storeInvoice',
            meta: {
              title: '总部发货',
            },
            component: storeInvoice,
          },
          {
            path: 'returnStoreInvoice',
            key: '/channel/returnStoreInvoice',
            meta: {
              title: '渠道账单',
            },
            component: returnStoreInvoice,
          },
          {
            path: 'withReturnStoreInvoice',
            key: '/channel/withReturnStoreInvoice',
            meta: {
              title: '总部收货',
            },
            component: withReturnStoreInvoice,
          },
          {
            path: 'billDetailsInvoice',
            key: '/channel/billDetailsInvoice',
            meta: {
              title: '渠道账单明细',
            },
            component: billDetailsInvoice,
          },
        ],
      },
      {
        path: '/onlineOrder',
        name: 'onlineOrder',
        key: '/onlineOrder',
        meta: {
          title: '线上订单导入',
        },
        component: KeepAliveRouteView,
        children: [
          {
            path: 'onlineDataImport',
            key: '/onlineOrder/onlineDataImport',

            meta: {
              title: '数据导入',
            },
            component: onlineDataImport,
          },
        ],
      },
      {
        path: '/miniShop',
        name: 'miniShop',
        key: '/miniShop',
        meta: {
          title: '微商城管理',
        },
        component: KeepAliveRouteView,
        children: [
          {
            path: 'miniShopOrder',
            key: '/miniShop/miniShopOrder',
            meta: {
              title: '微商城订单流水',
            },
            component: miniShopOrder,
          },
          {
            path: 'miniShopOrderDetail',
            key: '/miniShop/miniShopOrderDetail',
            meta: {
              title: '微商城订单明细',
            },
            component: miniShopOrderDetail,
          },
          {
            path: 'shop-decoration',
            key: '/miniShop/shop-decoration',
            meta: { title: '店铺装修' },
            redirect: 'shop-decoration/index',
            component: () => import('@/views/mini-shop/shop-decoration/index.vue'),
            children: [
              {
                path: 'editor',
                name: 'shopDecorationEditor',
                meta: {
                  title: '装修',
                },
                component: () => import('@/views/mini-shop/shop-decoration/editor/index.vue'),
              },
              {
                path: 'index',
                name: 'shopDecorationIndex',
                component: () => import('@/views/mini-shop/shop-decoration/list/index.vue'),
              },
            ],
          },
        ],
      },
      {
        path: '/set',
        name: 'set',
        key: '/set',
        meta: {
          title: '系统管理',
        },
        component: RouteView,
        children: [
          {
            path: 'print',
            key: '/set/print',
            meta: {
              title: '云盒打印管理',
            },
            component: print,
          },
          {
            path: 'print/design',
            key: '/set/print/design',
            meta: {
              title: '打印模板',
            },
            component: design,
          },
          {
            path: 'goods-import',
            key: '/set/goods-import',
            meta: {
              title: '商品导入',
              tenantTypeFilter: [11], // 只有这些tenantType才显示
            },
            component: () => import('@/views/set/goods-import/index.vue'),
          },
        ],
      },
    ],
  },
]

export default route
